
import { remove, apiToggle, combineReducers } from './common';

import {
  INVITE_DOMAIN,
  INVITE_DOMAIN_ERROR,
  REMOVE_DOMAIN,
  REMOVE_DOMAIN_SUCCESS,
  REMOVE_DOMAIN_ERROR
} from '../actions/domains';


/**
 * Invitation errors reducer
 * @param {Object} state an invitation
 * @param {Object} action 
 */
const errors = (state = [], action) => {
  switch (action.type) {
    case INVITE_DOMAIN_ERROR:
    case REMOVE_DOMAIN_ERROR:
      return state.concat([action.error.errors])
    default:
      return state;
  }
}

/** 
 * Invitation additonnal states
*/
const clientStates = combineReducers({
  // invitation errors
  errors,
  // true during the invitation process
  inviting: apiToggle(INVITE_DOMAIN),
  // true during the deleting process
  deleting: apiToggle(REMOVE_DOMAIN)
})

/**
 * Domain reducer
 * @param {Object} state a domain
 * @param {Object} action 
 */
const domain = (state = {}, action) => ({
  ...state,
  ...action.domain,
  ...clientStates(state, action)
});

/**
 * Generates a reducer that updates the corresponding domain 
 * in the domain store
 * @param {String} id A domain ID
 */
const withId = id => (state = {}, action) => ({
  ...state,
  [id]: {
    id,
    ...domain(state[id], action)
  }
});

/**
 * Domains reducer
 * @param {Object} state domains by id
 * @param {Object} action 
 */
const domains = (state = {}, action) => {

  const { domain, domainInvitationId } = action;

  if (domainInvitationId) {
    // if the action has an domainInvitationId (remove)
    switch (action.type) {
      case REMOVE_DOMAIN_SUCCESS:
      // it must be deleted from the store
        return remove(state, item => item.id === domainInvitationId);
      default:
        // otherwise, just forward the action
        return withId(domainInvitationId)(state, action);
    }
    
  }

  if (domain) {
    // if action has a domain, just forward action
    return withId(domain.id)(state, action);
  }

  return state;
}

export default domains;




// WEBPACK FOOTER //
// ./src/reducers/domains.js